import { useEffect, useState } from "react";
import { subscribeRecordingDurationUpdated } from "@/repositories/recordingLocalStateEvents";
import { formatMsToTime } from "@/utils/formatTime";

/**
 * Hook to listen for real-time duration updates from other tabs while a recording is in progress.
 * Updates the UI every second without querying IndexedDB or the backend.
 *
 * @param recordingUUID - The UUID of the recording to track
 * @returns The current duration in formatted string (HH:MM:SS) and raw milliseconds
 */
export const useRecordingDuration = (recordingUUID: string | undefined) => {
  const [duration, setDuration] = useState<number>(0);
  const [formattedDuration, setFormattedDuration] = useState<string>("00:00:00");

  useEffect(() => {
    if (!recordingUUID) return;

    const unsubscribe = subscribeRecordingDurationUpdated((event) => {
      if (event.recordingUUID !== recordingUUID) return;

      setDuration(event.duration);
      setFormattedDuration(formatMsToTime(event.duration));
    });

    return unsubscribe;
  }, [recordingUUID]);

  return { duration, formattedDuration };
};
